module.exports = __webpack_public_path__ + "img/dzdp02.edf45886.png";